export const msalConfig = {
  auth: {
    clientId: "756f40ff-128f-4959-96e9-27ff65fced0d",
    authority: "https://login.microsoftonline.com/f16b0d64-c314-4481-adca-7a599aa11e34",
    redirectUri: "https://lager.artaker.it",
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
